import React from 'react';
import { Container, Typography, Box, Grid, Paper } from '@mui/material';

const AboutUs = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Typography variant="h3" gutterBottom fontWeight={700}>About Us</Typography>
      <Typography variant="subtitle1" color="text.secondary" paragraph>
        Welcome to The Random Store – your destination for personalized and custom-made products crafted with creativity and care.
      </Typography>

      <Grid container spacing={4} sx={{ mt: 2 }}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: '100%' }} elevation={2}>
            <Typography variant="h5" gutterBottom>Who We Are</Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              We're a passionate team dedicated to transforming your ideas into unique products. Whether it's a gift, a keepsake, or something special for yourself, we aim to deliver items that carry meaning.
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              Every order is processed with attention to detail. We continuously evolve our catalog and customization options based on customer feedback and trends.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: '100%' }} elevation={2}>
            <Typography variant="h5" gutterBottom>What We Do</Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              We specialize in personalized products that let you express memories, moments, and emotions. From image-based items to text-driven designs, we blend technology and craftsmanship.
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              Our process ensures quality output—from upload and design validation to production and safe delivery.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: '100%' }} elevation={2}>
            <Typography variant="h5" gutterBottom>Our Values</Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              • Customer-first mindset
              <br />• Quality over quantity
              <br />• Transparency in process
              <br />• Respect for your data & privacy
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: '100%' }} elevation={2}>
            <Typography variant="h5" gutterBottom>Why Choose Us</Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              We make customization simple, reliable, and fast. Every image or text you share is handled securely and responsibly. Our automated cleanup ensures your creative assets aren't stored longer than needed.
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      <Box mt={6}>
        <Typography variant="h5" gutterBottom>Get in Touch</Typography>
        <Typography variant="body1" color="text.secondary">
          Have an idea or suggestion? We'd love to hear it. Visit our Contact page to reach out.
        </Typography>
      </Box>
    </Container>
  );
};

export default AboutUs;
